import React, { useEffect } from 'react';
import { connect } from "react-redux";
import * as Tools from "../../helpers/Tools";
import * as types from "../../constants/actionTypes";
import { logUI } from "../../api/andyliticsApi";
import { Link } from "react-router-dom";
import InHomeFaq from './InHomeFaq'
import { Grid, Typography, Icon, Button, Divider } from "../ecosystem/";

import SchedulingQuestions from './SchedulingQuestions'

const InHomeLanding = ({ costLabel, history, profileList, getPrefilledData }) => {

    useEffect(() => {
        logUI(`MBHWeb.UI.InHomeLanding.Displayed`, new Date(), Tools.getURLPath())
    }, []);

    return (
        <Grid className="body-content body-content--no-top-offset body-content--no-footer inhome inhome-landing-container">
            <div className="row inhome-landing-intro">
                <div className="col-12 maxWidth-content">
                    <div className="row">
                        <div className="col-12 inhome-landing-icon">
                            <Icon
                                name="covid-19-vaccine"
                                set="brand"
                                size="large"
                            />
                        </div>
                        <div className="col-12 inhome-landing-heading">
                            <Typography
                                type="heading-06"
                                tag="div"
                            >
                                You can now book your in-home vaccines
                            </Typography>
                        </div>
                        <div className="col-12 inhome-landing-subcontent">
                            <Typography
                                type="body-02"
                                tag="div"
                            >
                                Once the vaccine appointment is set, a trusted medical provider will visit your home, administer the vaccine, and document the entire encounter for your medical records.                            </Typography>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 inhome-landing-btn">
                            <Button
                                icon="calendar"
                                iconPosition="left"
                                onClick={() => {
                                    logUI(`MBHWeb.UI.InHomeLanding.BookVisit.Clicked`, new Date(), Tools.getURLPath());
                                    let route = `/inhomeschedules`;
                                    history.push(route);
                                    getPrefilledData(profileList)
                                }}
                            >
                                Book an in-home visit
                            </Button>
                        </div>
                    </div>
                </div>
            </div>

            <InHomeFaq />

            <div className="row">
                <div className="col-12 maxWidth-content">
                    <SchedulingQuestions textAlign="center" />
                </div>
            </div>

        </Grid>
    )
}

const mapStateToProps = (state) => {
    return {
        costLabel: state.memberships.inHomeVaccineCostLabel,
        profileList: state.memberships.profileList,
    }
}
const mapDispatchToProps = dispatch => {
    return {
        getPrefilledData: (selectedUsers) => {
            dispatch({ type: types.CHECK_GET_INHOME_PREFILL, selectedUsers });
        },
        cancelBooking: () => {
            dispatch({ type: types.CANCEL_INHOME_BOOKING });
        }
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(InHomeLanding);